import { withDefaultProviders } from 'src/hocs'
import { useUser } from 'src/hook/useUser'
import { AuthStatus } from '@hotmart/space-lib/dist/enum'
import { lazy, Suspense } from 'react'
import { jwt } from 'src/utils'
import { useSidebarMenu } from 'src/hook/useSidebarMenu'
import { useLocation, matchPath } from 'react-router-dom'

import { paths } from 'src/router/paths'
import { ErrorBoundary } from '../errorBoundary'
import { CommunityListMenuProps } from './communityListMenu.types'
import { Menu } from './components'

const ManagementEventsWrapper = lazy(() => import('communityManagement/ManagementEventsWrapper'))

const CommunityListMenu = ({ className }: CommunityListMenuProps) => {
  const { authStatus, user } = useUser()
  const { isOpenMenu } = useSidebarMenu()
  const { pathname } = useLocation()

  const showManagementEventsWrapper = Boolean(
    authStatus === AuthStatus.AUTHENTICATED && !jwt.isExpired(user?.token)
  )

  const isCommunityPath = Boolean(matchPath(`${paths.COMMUNITIES_PATH}/*`, pathname))

  const shouldHideMenu =
    !isCommunityPath && (!isOpenMenu || authStatus === AuthStatus.AUTHENTICATING)

  if (shouldHideMenu) {
    return null
  }

  return (
    <div slot="items" className={className}>
      <Menu />

      {showManagementEventsWrapper && (
        <ErrorBoundary>
          <Suspense fallback={null}>
            <ManagementEventsWrapper parentAppUser={user} />
          </Suspense>
        </ErrorBoundary>
      )}
    </div>
  )
}

export default withDefaultProviders(CommunityListMenu)
